export * from './lib/dialog.component';
